var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWarning(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.69471 2.23259C9.54132 1.91314 9.30079 1.64354 9.00084 1.45484C8.7009 1.26613 8.35374 1.16602 7.99938 1.16602C7.64501 1.16602 7.29786 1.26613 6.99791 1.45484C6.69797 1.64354 6.45744 1.91314 6.30404 2.23259L0.893378 12.8759C0.246044 14.1466 1.06404 15.8339 2.58804 15.8339H13.41C14.9347 15.8339 15.7514 14.1473 15.1054 12.8759L9.69471 2.23259ZM7.99938 5.83392C8.17619 5.83392 8.34576 5.90416 8.47078 6.02918C8.59581 6.15421 8.66604 6.32378 8.66604 6.50059V9.83392C8.66604 10.0107 8.59581 10.1803 8.47078 10.3053C8.34576 10.4303 8.17619 10.5006 7.99938 10.5006C7.82257 10.5006 7.653 10.4303 7.52797 10.3053C7.40295 10.1803 7.33271 10.0107 7.33271 9.83392V6.50059C7.33271 6.32378 7.40295 6.15421 7.52797 6.02918C7.653 5.90416 7.82257 5.83392 7.99938 5.83392ZM7.99938 11.5006C8.17619 11.5006 8.34576 11.5708 8.47078 11.6958C8.59581 11.8209 8.66604 11.9904 8.66604 12.1673V12.5006C8.66604 12.6774 8.59581 12.847 8.47078 12.972C8.34576 13.097 8.17619 13.1673 7.99938 13.1673C7.82257 13.1673 7.653 13.097 7.52797 12.972C7.40295 12.847 7.33271 12.6774 7.33271 12.5006V12.1673C7.33271 11.9904 7.40295 11.8209 7.52797 11.6958C7.653 11.5708 7.82257 11.5006 7.99938 11.5006Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWarning);
export default __webpack_public_path__ + "static/media/warning.6eec559bcdc63973f385b9eecaf71c72.svg";
export { ForwardRef as ReactComponent };